import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles({
  root: {
    position: 'absolute',
  },
  outlined: {
    outline: '1px solid green',
  },
});

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
